import { render } from "./starting-point-simplified.vue?vue&type=template&id=852c9bc2&scoped=true&ts=true"
import script from "./starting-point-simplified.vue?vue&type=script&lang=ts"
export * from "./starting-point-simplified.vue?vue&type=script&lang=ts"

import "./starting-point-simplified.vue?vue&type=style&index=0&id=852c9bc2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-852c9bc2"]])

export default __exports__